import React from "react";
import Messages from "./Messages";

export const Spam = () => (
  <Messages
    defaultStatus="spam"
    titleOverride="Spam Queue"
    eyebrowOverride="SPAM"
    subOverride="Restore false positives or leave them buried. They never appear on the public feed."
    hideStatusFilter
  />
);

export default Spam;
